import React, { Component } from "react";
import { LayersButton } from "./LayersButton/LayersButton";
import { Divider } from "./../../.common/Divider/Divider"
import { SelectedLayerList } from "./SelectedLayerList/SelectedLayerList";
import { LayoutContext } from "../../../modules/ContextModules/LayoutContext";

import './RightPanel.css'

export class RightPanel extends Component {
    static contextType = LayoutContext;
    render() {
        return (
            <div className="rightPanel noPrint">
                <LayersButton onClick={this.layersButtonClick}/>
                <Divider />
                <SelectedLayerList />
            </div>
        );
    }

    layersButtonClick = () => {
        this.context
        .draggableWindowContext
        .layersMap
        .update({
            isOpened: true,
            isMinimized: false
        });
    }
}
    